import React, { FC } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import QRCode from 'react-qr-code';
import Cookies from 'js-cookie';
import { CONSTANTS } from 'config/constants';

const { TOKEN_KEY, REACT_APP_MOBILE_UTILS_URL } = CONSTANTS;

type ScanMobileDialogProps = {
    open: boolean;
    onClose: () => void;
};
const ScanMobileDialog: FC<ScanMobileDialogProps> = ({ open, onClose }: ScanMobileDialogProps) => {
    const { t: translate } = useTranslation(['order-forms', 'common']);

    const qrCodeValue = () => {
        const value = `${REACT_APP_MOBILE_UTILS_URL}/order-scanner?token=${btoa(Cookies.get(TOKEN_KEY) || '')}`;
        console.log(value);
        return value;
    };

    return (
        <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
            <DialogTitle sx={{ textAlign: 'center' }}>{translate('order-forms:SCAN_USING_PHONE')}</DialogTitle>
            <DialogContent>
                <Box mb={2}>{translate('order-forms:SCAN_USING_PHONE_INSTRUCTIONS')}</Box>
                <Box display="flex" justifyContent="center">
                    <QRCode size={200} value={qrCodeValue()} />
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Button onClick={onClose}>{translate('common:CLOSE')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ScanMobileDialog;
